module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_5.f850d081.png";